import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-lock',
  templateUrl: './context-menu-lock.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuLockComponent {
  @Input()
  locked?: boolean;

  @Output()
  lockedChanged = new EventEmitter<boolean>();
}
